import ResourceTypeIcon from "./ResourceTypeIcon";

export default ResourceTypeIcon;